import { Component, OnInit } from '@angular/core';
import {PopoverController} from "@ionic/angular";

@Component({
  selector: 'app-cancelation-reason-popover',
  templateUrl: './cancelation-reason-popover.component.html',
  styleUrls: ['./cancelation-reason-popover.component.scss'],
})
export class CancelationReasonPopoverComponent implements OnInit {

  textValue = '';

  constructor(private popoverCtrl: PopoverController) {}

  send() {
    this.popoverCtrl.dismiss(this.textValue);
  }

  close() {
    this.popoverCtrl.dismiss();
  }

  ngOnInit(): void {
  }

}
